import { Map } from 'immutable';
import * as authActions from '../actions/auth';

import * as fetchingState from '../constants/fetchingState';
import { getErrorMessage } from '../constants/errorCode';

const initialState = new Map({
    fetching: fetchingState.INITIAL,
    error: undefined,
    user: undefined
});

function getDepartmentAddress(department) {
    return {
        Address: department ? department.Address : undefined,
        Entrance: department ? department.Entrance : undefined,
        Flat: department ? department.Flat : undefined,
        Floor: department ? department.Floor : undefined,
        GeoAddress: department ? department.GeoAddress : undefined,
        Id: department ? department.Id : undefined,
        IntercomCode: department ? department.IntercomCode : undefined
    }
}

export default function(auth, action) {
    if (action.data && action.data.refresh) {
        sessionStorage.removeItem('man-token');
        sessionStorage.removeItem('role');
        return initialState;
    }

    switch (action.type) {

        case authActions.FETCH_AUTH:
        case authActions.LOAD_AUTH:
            if (sessionStorage.getItem('pendingOrdersCount') != null)
                sessionStorage.removeItem('pendingOrdersCount');
            if (sessionStorage.getItem('cachedCallbacksCount'))
                sessionStorage.removeItem('cachedCallbacksCount');
            auth = auth.update('fetching', () => fetchingState.FETCHING);
            auth = auth.update('error', () => undefined);
            break;

        case authActions.FAILURE_AUTH:
        case authActions.FAILURE_LOAD_AUTH:
            sessionStorage.removeItem('man-token');
            sessionStorage.removeItem('role');
            auth = initialState;
            auth = auth.update('fetching', () => fetchingState.FAILED);
            auth = auth.update('error', () => getErrorMessage(action.data.error));
            break;

        case authActions.LOSE_AUTH:
            sessionStorage.removeItem('man-token');
            sessionStorage.removeItem('role');
            auth = initialState;
            break;

        case authActions.SUCCESS_AUTH:
            {
                const { Name, Token, Roles, Department, error } = action.data;

                if (error === undefined) {
                    sessionStorage.setItem('man-token', Token);
                    sessionStorage.setItem('role', Roles);
                    auth = auth.update('user', () => new Map({ Name: Name, Role: Roles, Department, Address: getDepartmentAddress(Department) }));
                    auth = auth.update('fetching', () => fetchingState.FETCHED);
                } else {
                    auth = initialState;
                    auth = auth.update('fetching', () => fetchingState.FETCHED);
                    auth = auth.update('error', () => getErrorMessage(error));
                }
                break;
            }

        case authActions.SUCCESS_LOAD_AUTH:
            {
                const { Name, Roles, Department, expired, malformed } = action.data;

                if (expired || malformed) {
                    sessionStorage.removeItem('man-token');
                    sessionStorage.removeItem('role');
                    auth = initialState
                } else {
                    auth = auth.update('user', () => new Map({ Name: Name, Role: Roles, Department, Address: getDepartmentAddress(Department) }));
                }
                break;
            }

        default:
            return auth;
    }
    return auth;
};


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js